<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <el-form-item label="Id：" class="form-item-b0">
            <el-input v-model="query.userId" placeholder="请输入Id" size="small" clearable></el-input>
          </el-form-item>

          <el-form-item label="userCode：" class="form-item-b0">
            <el-input v-model="query.userCode" placeholder="请输入Id" size="small" clearable></el-input>
          </el-form-item>

          <el-form-item label="注册时间：" class="form-item-b0">
            <el-date-picker
              v-model="beginDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="近期" class="form-item-b0">
            <span
              :class="current === 4 ? 'blue' : ''"
              style="margin-left: 20px; cursor: pointer"
              @click="getList('place', 2)"
              >昨天</span
            >
            <span
              :class="current === 2 ? 'blue' : ''"
              style="margin-left: 20px; cursor: pointer"
              @click="getList('place', 1)"
              >今天</span
            >
            <span
              :class="current === 1 ? 'blue' : ''"
              style="margin: 0 20px; cursor: pointer"
              @click="getList('place', 7)"
              >7天</span
            >
            <span :class="current === 3 ? 'blue' : ''" style="cursor: pointer" @click="getList('place', 30)">30天</span>
          </el-form-item>
        </el-form>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>

          <el-button size="small" @click="init()">重置</el-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column label="序" align="center" type="index" min-width="50"></el-table-column>

      <el-table-column prop="StorePhone" label="手机号码" align="center" min-width="80">
        <template slot-scope="scope">
          <div style="cursor: pointer" @click.stop="query.search = scope.row.StorePhone">
            {{ scope.row.StorePhone }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="UserCode" label="userCode" align="center" min-width="60"></el-table-column>

      <el-table-column prop="StoreHeadImage" label="头像" align="center" min-width="50">
        <template slot-scope="scope">
          <template v-if="scope.row.StoreHeadImage">
            <el-avatar :size="30" fit="contain" :src="scope.row.StoreHeadImage"></el-avatar>
          </template>
          <template v-else>--</template>
        </template>
      </el-table-column>

      <el-table-column prop="ParentId" label="上线Id" align="center" min-width="60"></el-table-column>

      <el-table-column prop="CreateTime" label="创建时间" align="center" min-width="108">
        <template slot-scope="scope">
          {{ new Date(scope.row.CreateTime) | parseTime('{y}-{m}-{d} {h}:{i}') }}
        </template>
      </el-table-column>

      <el-table-column prop="LastUseTime" label="最后访问时间" align="center" min-width="108">
        <template slot-scope="scope">
          {{ new Date(scope.row.LastUseTime) | parseTime('{y}-{m}-{d} {h}:{i}') }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onEditInfo(scope.row)"> 编辑 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[20, 40, 60, 100, 1000, total]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 编辑会员资料 -->
    <el-dialog
      :visible.sync="editPhoneDialog"
      class="FormDialogBox"
      width="600px"
      title="编辑会员资料"
      :close-on-click-modal="false"
      @close="editPhoneCancel()"
    >
      <el-form label-width="auto" :model="editForm" :rules="rules" ref="ruleForm">
        <div style="display: flex">
          <el-form-item label="手机号" prop="Phone">
            <el-input v-model="editForm.Phone" placeholder="手机号" clearable maxlength="11"></el-input>
          </el-form-item>

          <el-form-item label="状态">
            <el-switch
              v-model="editForm.Status"
              :active-value="1"
              :inactive-value="0"
              @change="editStatus(editForm)"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="IP">
            <span>{{ editForm.LastLoginIp }}</span>
          </el-form-item>

          <el-form-item label="">
            <el-button type="primary" size="mini" @click="onAccess(editForm.LoginName)">访问</el-button>
          </el-form-item>
        </div>

        <el-form-item label="头像">
          <el-upload
            ref="upload"
            action="https://api.chajiuqu.com/api/current/uploadimage"
            list-type="picture-card"
            :file-list="myImage"
            :limit="1"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editPhoneDialog = false">取 消</el-button>
        <el-button type="primary" @click="editPhoneDetermine()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="accessDialog"
      class="FormDialogBox"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      @close="accessDialogClose"
    >
      <div style="min-height: 500px">
        <ShowTableInfo
          ref="ShowTableInfoRef4"
          :underPagination="false"
          :showItem="showItem4"
          :getListFn="getListFn4"
          :param="accessParam"
          :paramChangeGetList="true"
          :showPagination="false"
        >
          <template slot="VipTime" slot-scope="scope">
            <span>{{ new Date(scope.data.VipTime) | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import regionArr from '@/utils/citys.json'
import XLSX from 'xlsx'

export default {
  name: 'membersIndex',
  data() {
    return {
      StoreBannerImage: '',
      StoreIDImage: '',
      StoreIDImage2: '',
      StoreLicenseImage: '',
      imageUrl: '',
      options: [
        {
          value: '选项1',
          label: '全部'
        },
        {
          value: '选项2',
          label: '已过期'
        }
      ],
      value: '全部',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      list: [],
      loading: true,
      LoginDate: [],
      beginDate: [
        this.$globalFun.parseTime(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7), '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
      ],
      query: {
        pageindex: 1,
        pagesize: 20,
        userChannel: 2,
        userId: '',
        userCode: '',
        search: '',
        status: null,
        isvip: null
      },
      total: 0, // 总条数
      // 修改手机号
      editPhoneDialog: false,
      editForm: {
        Phone: '',
        PassWord: '',
        VipTime: '',
        Level: '',
        Integral: '',
        Province: '',
        City: '',
        Area: ''
      },
      editForm2: {},
      rules: {
        Phone: [
          { required: true, message: ' ', trigger: 'blur' },
          { pattern: /^1[3|4|5|6|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'change' }
        ],
        // PassWord: [{ required: true, message: '密码长度6-12', trigger: 'change' }],
        VipTime: [{ required: true, message: ' ', trigger: 'change' }],
        Level: [{ required: true, message: ' ', trigger: 'blur' }],
        Integral: [{ required: true, message: ' ', trigger: 'blur' }]
        // Province: [{ required: true, message: '请选择省市区', trigger: 'change' }]
      },
      ruleStore: {
        StorePhone: [
          { required: true, message: ' ', trigger: 'blur' },
          { pattern: /^1[3|5|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'change' }
        ],
        StoreName: [{ required: true, message: ' ', trigger: 'blur' }],
        Province: [{ required: true, message: ' ', trigger: 'blur' }],
        City: [{ required: true, message: ' ', trigger: 'blur' }],
        Area: [{ required: true, message: ' ', trigger: 'blur' }],
        StoreAddress: [{ required: true, message: ' ', trigger: 'blur' }],
        Longitude: [{ required: true, message: ' ', trigger: 'blur' }],
        Latitude: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      // 省市区
      region: null,
      regionOptions: regionArr,

      excelDialogVisible: false,

      editStoreDialog: false,

      current: 1,

      cardName: '',
      bankCard: '',
      bankOfDeposit: '',

      topUpWaterDialog: false,
      topUpWaterPhone: '',

      showItem4: [
        {
          prop: 'Date',
          label: '日期'
        },
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'LogCount',
          label: '访问次数'
        }
      ],
      accessDialog: false,
      accessParam: {
        begindate: this.$globalFun.parseTime(
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 10),
          '{y}-{m}-{d}'
        ),
        enddate: this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}'),
        pageindex: 1,
        search: ''
      }
    }
  },
  created() {
    this.getList('place', 7)
  },
  computed: {
    myImage: function () {
      const arr = []
      if (this.editForm.StoreHeadImage) {
        arr.push({
          url: this.editForm.StoreHeadImage
        })
      }
      return arr
    }
  },
  methods: {
    // 初始化
    init() {
      this.query.userId = ''
      this.query.userCode = ''
      this.query.search = ''
      this.LoginDate = []
      this.beginDate = []
      this.query.status = null
      this.query.isvip = null

      this.current = 0
      this.region = null

      this.getList('place')
    },

    // 导出excel
    exportExcel() {
      console.log(XLSX, this.list)
      this.excelDialogVisible = false
      if (this.list.length === 0) {
        this.$message.warning('暂无数据')
        return
      }
      const exportList = [['手机号']]
      this.list.forEach((item) => {
        exportList.push([item.LoginName])
      })
      const sheet = XLSX.utils.aoa_to_sheet(exportList)
      this.openDownloadDialog(this.sheet2blob(sheet), '过期会员手机号.xlsx')
    },

    sheet2blob(sheet, sheetName) {
      sheetName = sheetName || 'sheet1'
      var workbook = {
        SheetNames: [sheetName],
        Sheets: {}
      }
      workbook.Sheets[sheetName] = sheet
      // 生成excel的配置项
      var work = {
        bookType: 'xlsx', // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: 'binary'
      }
      var xlsx = XLSX.write(workbook, work)
      var blob = new Blob([s2ab(xlsx)], { type: 'application/octet-stream' })
      // 字符串转ArrayBuffer
      function s2ab(s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }
      return blob
    },

    openDownloadDialog(url, saveName) {
      if (typeof url === 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url) // 创建blob地址
      }
      var aLink = document.createElement('a')
      aLink.href = url
      aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      var event
      if (window.MouseEvent) event = new MouseEvent('click')
      else {
        event = document.createEvent('MouseEvents')
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      }
      aLink.dispatchEvent(event)
    },

    handleAvatarSuccess(res, file, filelist) {
      // console.log(res, file, filelist)
      this.imageUrl = res.data
    },
    handleRemove(file, filelist) {
      console.log(file, filelist)
      this.editForm.StoreHeadImage = ''
      this.imageUrl = ''
    },

    // 图片上传
    handleAvatarSuccess1(res, file, filelist) {
      this.StoreBannerImage = res.data
    },
    handleRemove1(file, filelist) {
      console.log(file, filelist)
      this.StoreBannerImage = ''
    },
    handleAvatarSuccess2(res, file, filelist) {
      this.StoreIDImage = res.data
    },
    handleRemove2(file, filelist) {
      this.StoreIDImage = ''
    },
    handleAvatarSuccess3(res, file, filelist) {
      this.StoreIDImage2 = res.data
    },
    handleRemove3(file, filelist) {
      this.StoreIDImage2 = ''
    },
    handleAvatarSuccess4(res, file, filelist) {
      this.StoreLicenseImage = res.data
    },
    handleRemove4(file, filelist) {
      this.StoreLicenseImage = ''
    },

    // async exportExcel() {
    //   this.excelDialogVisible = false
    //   if (!this.LoginDate || !this.LoginDate.length) {
    //     delete this.query.beginLoginTime
    //     delete this.query.endLoginTime
    //   } else {
    //     this.query.beginLoginTime = this.LoginDate[0]
    //     this.query.endLoginTime = this.LoginDate[1]
    //   }

    //   if (!this.beginDate || !this.beginDate.length) {
    //     delete this.query.beginTime
    //     delete this.query.endTime
    //   } else {
    //     this.query.beginTime = this.beginDate[0]
    //     this.query.endTime = this.beginDate[1]
    //   }
    //   console.log(this.query)
    //   delete this.query.pageindex
    //   delete this.query.pagesize
    //   const { data } = await this.$api.members.exportExcel(this.query)
    //   console.log('excel-url', data)
    //   window.location.href = data
    // },

    // 获取列表
    async getList(place, day) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        this.$nextTick(() => {
          this.$refs.TableListRef.bodyWrapper.scrollTop = 0
        })
      }

      if (!this.LoginDate || !this.LoginDate.length) {
        delete this.query.beginLoginTime
        delete this.query.endLoginTime
      } else {
        this.query.beginLoginTime = this.LoginDate[0]
        this.query.endLoginTime = this.LoginDate[1]
      }

      if (!this.beginDate || !this.beginDate.length) {
        delete this.query.beginTime
        delete this.query.endTime
      } else {
        this.query.beginTime = this.beginDate[0]
        this.query.endTime = this.beginDate[1]
      }

      if (day) {
        this.query.endTime = this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
        this.query.beginTime = this.$globalFun.parseTime(
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * (day - 1)),
          '{y}-{m}-{d}'
        )
        this.beginDate[0] = this.query.beginTime
        this.beginDate[1] = this.query.endTime
        if (day === 7) this.current = 1
        if (day === 1) this.current = 2
        if (day === 2) {
          this.current = 4
          this.query.endTime = this.query.beginTime
          this.beginDate[0] = this.query.beginTime
          this.beginDate[1] = this.query.endTime
        }
        if (day === 30) this.current = 3
      } else {
        this.current = 0
      }

      if (this.query.search || this.query.userId) {
        delete this.query.beginTime
        delete this.query.endTime
      }

      const query = {
        ...this.query
      }
      if (!query.userId) {
        delete query.userId
      }
      if (!query.userCode) {
        delete query.userCode
      }
      console.log(query)

      const { data: res } = await this.$api.members.getMembersList(query)
      console.log('获取列表', res)

      this.loading = false
      this.list = res.list
      this.total = res.count

      // const { data } = await this.$api.user.loglist({
      //   pageindex: 1,
      //   pagesize: 10,
      //   search: '13542884241'
      // })
      // console.log('data', data)
    },
    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },

    // 状态改变
    async editStatus(item) {
      console.log('状态改变', item)

      try {
        const form = {
          listid: [item.Id],
          status: item.Status
        }
        await this.$api.members.editMembersStatus(form)
        this.$message.success('状态改变成功')
        this.getList()
      } catch (e) {
        this.getList()
      }
    },

    async onTopUpWater(LoginName) {
      console.log(LoginName)
      this.topUpWaterPhone = LoginName

      await this.$nextTick()
      this.topUpWaterDialog = true
    },

    topUpWaterCancel() {
      this.topUpWaterDialog = false
      this.topUpWaterPhone = ''
    },

    // 编辑会员信息
    onEditInfo(item) {
      const form = this.$globalFun.deepClone(item)
      form.Phone = form.LoginName
      this.editForm = form
      this.region = [this.editForm.Province, this.editForm.City, this.editForm.Area]
      this.bankCard = this.editForm.BankCard
      this.cardName = this.editForm.CardName
      this.bankOfDeposit = this.editForm.BankOfDeposit
      console.log('editForm', this.editForm)
      this.editPhoneDialog = true
    },
    editPhoneCancel() {
      // console.log('对话框关闭')
      this.editForm = {}
      this.imageUrl = ''
      this.region = null
      this.bankCard = ''
      this.cardName = ''
      this.bankOfDeposit = ''
    },
    async editPhoneDetermine() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return

        if (this.imageUrl.length > 0) {
          this.editForm.StoreHeadImage = this.imageUrl
        }
      })

      const StoreheadImage = this.editForm.StoreHeadImage
        ? this.editForm.StoreHeadImage
        : 'https://api.chajiuqu.com/uploadImage/img/defaultPict.png'

      const form = {
        Id: this.editForm.Id,
        StoreheadImage
      }

      await this.$api.members.edit(form)

      this.$message.success('修改成功')

      this.editForm = {}
      this.imageUrl = ''
      this.getList()
      this.editPhoneDialog = false
    },

    getListFn4(query) {
      return this.$api.user.loglist(query)
    },

    onAccess(search) {
      console.log('getAccessList', search)
      this.accessParam = {
        ...this.accessParam,
        search
      }

      this.accessDialog = true
    },

    accessDialogClose() {
      this.accessDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  font-size: 12px !important;
}
</style>
